import { render } from "./EspeEmpr.vue?vue&type=template&id=2281469b&scoped=true"
import script from "./EspeEmpr.vue?vue&type=script&lang=js"
export * from "./EspeEmpr.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=2281469b&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=1&id=2281469b&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2281469b"]])

export default __exports__